import axios from "axios";

import { BASEURL } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";

export function ApiFund() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const url = BASEURL + "fundsmanagement/";
  return {
    addFund: (newRecord) =>
      authAxios.post(url + "addInfaqCashInHand/", newRecord),
    addSingleInfaqAmanat: (newRecord) =>
      authAxios.post(url + "AddInfaqAmanatAccount/", newRecord, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    getInfaqRequestDetail: (notificationId) =>
      authAxios.get(`${url}GetInfaqRequestDetail/${notificationId}`),
    UpdateNotificationInfaqToAmanat: (record) =>
      authAxios.post(url + "UpdateNotificationInfaqToAmanat", record),
    addBulkFund: (newRecord) => authAxios.post(url + "addBulk/", newRecord),
    getMembersFundsDetails: (newRecord) =>
      authAxios.post(url + "getMembersFundsDetails/", newRecord),
    getUnitWiseFundsDetails: (newRecord) =>
      authAxios.post(url + "GetUnitWiseFundsDetails/", newRecord),
    getList: (unitId, memberId) =>
      authAxios.get(url + "getList/" + unitId + "/" + memberId),
    getById: (id) => authAxios.get(url + "edit/" + id),
    update: (id, updateRecord) => {
      const isFormData = updateRecord instanceof FormData;
      return authAxios.put(url + "edit/" + id, updateRecord, {
        headers: isFormData ? { "Content-Type": "multipart/form-data" } : {}
      });
    },
    deleteFund: (id, type) =>
      authAxios.delete(url + "delete/" + id + "/" + type),
    GetUnitWiseFundsDetailsExcelReport: (newRecord) =>
      authAxios.post(url + "GetUnitWiseFundsDetailsExcelReport/", newRecord, {
        responseType: "blob",
      }),
    GetUnitWiseFundsDetailsPdfReport: (newRecord) =>
      authAxios.post(url + "GetUnitWiseFundsDetailsPdfReport/", newRecord, {
        responseType: "blob",
      }),

    GetMembersFundsDetailsPdfReport: (newRecord) =>
      authAxios.post(url + "GetMembersFundsDetailsPdfReport/", newRecord, {
        responseType: "blob",
      }),

    GetMembersFundsDetailsExcelReport: (newRecord) =>
      authAxios.post(url + "GetMembersFundsDetailsExcelReport/", newRecord, {
        responseType: "blob",
      }),
    GetInfaqTransactions: (record) =>
      authAxios.post(url + "GetInfaqTransactions", record),

    GenerateReceipt: (transactionNo, type) =>
      authAxios.get(url + "GenerateReceipt/" + transactionNo + "/" + type, { responseType: "blob" }),
    GenerateExpenseVoucher: (transactionNo) =>
      authAxios.get(url + "GenerateExpenseVoucher/" + transactionNo, { responseType: "blob" }),
    GetUsraReceipt: (receiptToken) =>
      authAxios.get(url + "GetUsraReceipt/" + receiptToken, { responseType: "blob" }),
    GetUsraHolding: (unitId) => authAxios.get(url + "GetUsraHolding/" + unitId),
    RequestUsraRemittance: (record) =>
      authAxios.post(url + "RequestUsraRemittance", record),
    GetUsraRemittanceDetail: (notificationId) =>
      authAxios.get(url + "GetUsraRemittanceDetail/" + notificationId),
    GetIncomingUsraRemittances: (tanzeemUnitId) =>
      authAxios.get(url + "GetIncomingUsraRemittances/" + tanzeemUnitId),
    UsraRemittanceAction: (record) =>
      authAxios.post(url + "UsraRemittanceAction", record),
    GetUsraCashInTransit: (record) =>
      authAxios.post(url + "GetUsraCashInTransit", record),
    RetryUsraRemittancePosting: (remittanceId) =>
      authAxios.post(url + "RetryUsraRemittancePosting/" + remittanceId),
    SearchUsraInfaq: (record) =>
      authAxios.post(BASEURL + "usrainfaq/Search", record),
    GetUsraInfaq: (id) => authAxios.get(BASEURL + "usrainfaq/Get/" + id),
    UpdateUsraInfaq: (id, record) =>
      authAxios.put(BASEURL + "usrainfaq/Update/" + id, record),
    VoidUsraInfaq: (id, record) =>
      authAxios.post(BASEURL + "usrainfaq/Void/" + id, record),
  };
}
